module.exports = __webpack_public_path__ + "img/bn_right.37373d54.png";